import { render, staticRenderFns } from "./GreetModal.vue?vue&type=template&id=be081336&"
import script from "./GreetModal.vue?vue&type=script&lang=js&"
export * from "./GreetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports